import '../../transactions/export/styles.scss';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import l from '../../../../lang';
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/file-download.svg';
import { Filters } from '../../../../store/interfaces';
import { useClients } from '../../../../store/clients';
import DialogExportClients from './dialog';

interface ExportClientsProps {
  filters: Filters;
}

const ExportClients = ({ filters }: ExportClientsProps) => {
  const { export: exportState, showExportClients } = useClients();

  return (
    <>
      <div className="export_transactions__top_button">
        <ButtonCustom
          text={<span className="export_transactions__top_button__text">{l('clients.export.title')}</span>}
          onClick={() => showExportClients(true)}
          variant="outlined"
          disabled={exportState.loading}
          startIcon={<DownloadIcon className="export_transactions__top_button__icon" />}
          fullWidth={false}
        />
      </div>
      <DialogExportClients listFilters={filters} />
    </>
  );
};

export default ExportClients;
